
import React from 'react';
import PropTypes from 'prop-types';

import RC1Img1 from '../InstallImages/RoofTopCanopyImages/RTCImg1';
import RC1Img2 from '../InstallImages/RoofTopCanopyImages/RTCImg2';
import RC1Img4 from '../InstallImages/RoofTopCanopyImages/RTCImg4';


import '../saleslogic.css';
import '../../../../../../grid.css';

const RoofTopCanopy = (props) => {
    const {
        firstName,
    } = props;

    // images are 952 x 406

    return (
        <div className="row" >
            <h1 className="arrayType">Rooftop Solar Canopy</h1>
            <div className="row installTextGroup">
                <p className="col span-1-of-3 installText">{firstName}, after analyzing your electrical consumption and site conditions at your location, we conclude that installing your PV solar-generating system on a Rooftop Canopy maximizes its value. We base our decision on decades of experience and careful consideration of many factors, including roof area, roof obstructions, shading, electrical consumption, and available ground space. We also determine that your Rooftop Canopy is the ideal place to maximize your financial benefits and ensure that your Solvana PV solar-generating system meets or exceeds your expectations.
                    <div className="row canopyMovieLink">
                        <a target="_blank" rel="noopener noreferrer" href="https://player.vimeo.com/video/388343741">Check out our video here</a>
                    </div>
                </p>

                <p className="col span-2-of-3 installPics"><RC1Img1 /></p>

            </div>
            <div className="row installTextGroup">
                <p className="col span-2-of-3 installPics"><RC1Img2 /></p>
                <p className="col span-1-of-3 installText">Solvana elevates the PV solar modules on Rooftop Canopies to approximately 9-feet off the deck, so you benefit even further when using bi-facial PV solar modules by capturing light from the sun that reflects off of roofing surfaces and surrounding areas. Albedo is the measure of the diffuse reflection of solar radiation out of the total solar radiation. High Albedo ratios yield improved PV solar-generating system efficiencies up to 30%. Those are 30 percent bonuses year after year, and not just once!</p>
            </div>
            <div className="row installTextGroup">
                <p className="col span-1-of-3 installText">
                    For even more benefits, Solvana can coat your roofing surface with highly reflective white coatings to maximize the Albedo potential. That means we need less light to produce more electricity because Albedo increases due to the white roofing surface. And that increases your financial benefits without adding the cost of more PV solar equipment and components. And it gets even better: Ask our experts how new white roofs may be eligible for Investment Tax Credits, and rolled into loans, leases, or Power Purchase Agreements!
                </p>
                <p className="col span-2-of-3 installPics"><RC1Img4 /></p>
            </div>
        </div>
    );
};

RoofTopCanopy.propTypes = {
    firstName: PropTypes.string.isRequired,
};

export default RoofTopCanopy;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/RoofTopCanopy/RoofTopCanopy.js